import { render, staticRenderFns } from "./Register-ajuda.vue?vue&type=template&id=0cf3638b&"
import script from "./Register-ajuda.vue?vue&type=script&lang=js&"
export * from "./Register-ajuda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports